import { Col, Form, Row, Typography } from 'antd';
import { FormikProps } from 'formik';
import dayjs, { Dayjs } from 'dayjs';

import { MDatePicker } from '@Components/Base';
import { prepareDatePickerValue } from '@Utils/transformDateTime';

import { FormItemLayout } from 'antd/es/form/Form';
import styles from './date-range.module.css';

const ERROR_TEXT =
  'Please check the Date range. It should not finish before it was started';

interface DateRangeProps<T> {
  formik: FormikProps<T>;
  fromKey: string;
  toKey: string;
  fromLabel?: string;
  toLabel?: string;
  layout?: FormItemLayout;
  dataPickerClassName?: string;
}

const DateRange = <T,>({
  formik,
  fromKey,
  toKey,
  fromLabel,
  toLabel,
  layout,
  dataPickerClassName,
}: DateRangeProps<T>): JSX.Element => {
  const fromValue = formik.getFieldMeta(fromKey).value as Dayjs;
  const toValue = formik.getFieldMeta(toKey).value as Dayjs;

  const showError = toValue && fromValue && toValue < fromValue;

  return (
    <>
      <Row justify="space-between">
        <Col>
          <Form.Item label={fromLabel} layout={layout}>
            <MDatePicker
              value={fromValue && dayjs(fromValue)}
              onChange={(value) => {
                formik.setFieldValue(
                  fromKey,
                  prepareDatePickerValue(value, true)
                );
              }}
              className={dataPickerClassName}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label={toLabel} layout={layout}>
            <MDatePicker
              value={toValue && dayjs(toValue)}
              onChange={(value) => {
                formik.setFieldValue(toKey, prepareDatePickerValue(value));
              }}
              disabledDate={(current) => {
                return current && dayjs(current).endOf('day') < fromValue;
              }}
              className={dataPickerClassName}
            />
          </Form.Item>
        </Col>
      </Row>
      {showError ? (
        <Typography.Text className={styles.error}>{ERROR_TEXT}</Typography.Text>
      ) : null}
    </>
  );
};

export default DateRange;
